import { EntryMethod } from '../../common/enumerations/entry-method';
import { IItemLookup } from '../../common/interfaces/dtos/IItemLookup';
import { IScanData } from '../../common/interfaces/dtos/IScanData';
import { IItemLookupCriteria } from './service/product-lookup';
import { PolicyLookupNames, productLookupByPolicy } from './service/product-lookup-by-policy';

export const lookupItemById = async (
  scanData: IScanData,
  entryMethod: string = EntryMethod.Automatic,
  actionDescription: string = '',
  policy?: PolicyLookupNames,
): Promise<IItemLookup> => {
  const itemLookUps: IItemLookup[] = await lookupItemByCriteria(
    {
      scanData: [scanData],
      entryMethod,
      actionDescription,
    },
    policy,
  );
  return itemLookUps[0];
};

export const lookupItemByCriteria = async (
  criteria: IItemLookupCriteria,
  policy?: PolicyLookupNames,
): Promise<IItemLookup[]> => {
  let response: IItemLookup[] = [];

  if (criteria.scanData && criteria.scanData.length > 0) {
    response = await productLookupByPolicy(criteria, policy);
  } else {
    // TODO: In future call productLookup
  }
  return response;
};
